'use strict';

export function routeConfig($urlRouterProvider, $locationProvider) {
  'ngInject';

  $urlRouterProvider.otherwise('/');

  $locationProvider.html5Mode(true);
}

export function themeConfig($mdThemingProvider) {
  'ngInject';

  $mdThemingProvider.theme('default')
    .primaryPalette('blue')
    .accentPalette('orange')
    .backgroundPalette('grey');
}

export function rollbarConfig(RollbarProvider) {
  'ngInject';

  RollbarProvider.init({
    accessToken: 'c3b4399f7c404090a92eab4225266412',
    captureUncaught: true,
    captureUnhandledRejections: true,
    payload: {
      environment: 'production'
    }
  });
}



// WEBPACK FOOTER //
// ./client/app/app.config.js